module.exports = __webpack_public_path__ + "1_0_65/img/Kalon.dc6ffb2d.jpg";